module.exports = __webpack_public_path__ + "static/media/meenakshi.3d96c50c.webp";